<template>
  <div>
    <SideBarFilter
      :filter="form"
      ref="sidebarSlot"
      placeholder="จัดการที่ว่างต่อสาขา"
      :hideStatusFilter="false"
      :hideSearchBar="true"
      title="จัดการที่ว่างต่อสาขา"
      textSubmit="บันทึก"
      hideFilter
      handleSideBar
      @searchAll="handleSave"
      :isLoading="isLoading"
      @clearLoading="isLoading = false"
      @clearForm="clearForm"
    >
      <template v-slot:filter-option>
        <div class="my-3">
          <InputText
            v-model="form.name"
            class="input"
            :textFloat="`ชื่อ`"
            placeholder="ชื่อ"
            type="text"
            name="name"
            isRequired
            :v="$v.form.name"
            :isValidate="$v.form.name.$error"
            :disabled="$route.query.type  == '0'"
          />
        </div>
        <div>
          <b-form-group label="รูปแบบที่ว่าง" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="isLimit"
              :options="optionSlot"
              :aria-describedby="ariaDescribedby"
              name="radios-slot"
              stacked
              @change="onChange"
            ></b-form-radio-group>
          </b-form-group>

          <InputText
            v-if="isLimit"
            v-model="form.defaultSlot"
            class="input"
            textFloat=""
            placeholder="จำนวนที่ว่าง"
            type="number"
            name="defaultSlot"
            isRequired
            :v="$v.form.defaultSlot"
            :isValidate="$v.form.defaultSlot.$error"
          />
        </div>
      </template>
    </SideBarFilter>
    <ModalAlertText :textModal="textModal" :arrModal="arrStatus" />
  </div>
</template>

<script>
import UploadFile from "@/components/inputs/UploadFile";
import ModalAlertText from "@/components/modal/ModalAlertText.vue";
import InputText from "@/components/inputs/InputText";
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
export default {
  name: "CategoryForm",
  components: {
    UploadFile,
    ModalAlertText,
    InputText,
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    id: {
      required: true,
      type: Number,
    },
    data: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      form: {
        name: "",
        defaultSlot: null,
      },

      isLoading: false,
      isLimit: false,

      // state modal
      textModal: "",
      arrStatus: [],
      optionSlot: [
        {
          value: false,
          text: "ไม่จำกัด",
        },
        {
          value: true,
          text: "จำกัด",
        },
      ],
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        defaultSlot: {
          required: requiredIf(() => {
            return this.isLimit;
          }),
        },
      },
    };
  },
  watch: {
    visible(val) {
      if (val === true) {
        this.$refs.sidebarSlot.show();
      } else {
        this.$refs.sidebarSlot.hide();
      }
    },
    data(val) {
      this.$v.$reset();
      this.form = val
        ? {
            ...val,
          }
        : {
            name: "",
            defaultSlot: null,
          };
      this.isLimit = Boolean(val.defaultSlot);
    },
  },
  mounted() {},
  computed: {},
  methods: {
    onChange(val) {
      if (!this.isLimit) this.form.defaultSlot = null;
    },
    handleSave() {
      this.$v.form.$touch();

      if (this.$v.form.$error) return;
      this.isLoading = true;
      this.$services.slotgroup
        .saveSlotGroupDetail(this.form, this.id)
        .then(async (res) => {
          const text = await res.message;
          this.openModalAlertText(text);
          this.clearForm();
          this.$emit("fetchTable");
        });
    },

    clearForm() {
      this.$emit("hideForm");
      this.isLoading = false;
    },
    openModalAlertText(text) {
      this.textModal = text;
      this.$bvModal.show("modal-alert-text");
    },
  },
};
</script>

<style lang="scss" scoped>
.render-image {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  height: 200px;
  border: 1px dashed gray;
}
.list-lang {
  display: flex;
  justify-content: right;

  .box-lang {
    padding: 5px 10px;
    margin-right: 5px;
    border: 1px solid black;
    cursor: pointer;

    &.active {
      background: var(--secondary-color);
      color: white;
    }
  }
}
</style>
